import { Injectable } from '@angular/core';
import moment from 'moment';

import { ApiService } from '@app/services';
import { StoreCheck, StoreCheckUpdateObjective, StoreCheckUpdateDto, StoreCheckObjectiveValueDto } from '@app/models';

export class UpdateStoreCheckObjectiveDto {
    scId: number;
    objId: number;
    storeId: number;
    salesRep: number;
    values: any;
}

@Injectable({
  providedIn: 'root'
})
export class StoreCheckService {

    constructor(
        private apiService: ApiService
    ) {}
    
    async loadStoreCheck(operationId: number, storeCheckId: number): Promise<StoreCheck|null> {
        let storeCheck: StoreCheck|null = null;
        let params = {
            ctxId: operationId
        }
        let response = await this.apiService.get('storecheckdashboard/' + storeCheckId, params);
        if(response?.data){
            storeCheck = response.data;
            if(storeCheck){
                storeCheck.contextId = operationId;
            }
        }
        return storeCheck;
    }
    
    async updateStoreCheck(operationId: number, storeCheckId: number, data: StoreCheckUpdateDto): Promise<boolean>{
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.post('storecheck/' + storeCheckId + '/update/programmable', data, params);
        return (response.error === null);
    }
    
    async duplicateStoreCheck(operationId: number, storeCheckId: number, startDate: Date): Promise<number|null>{
        let newStoreCheckId: number|null = null;
        let params = {
            ctxId: operationId,
            startDate: moment(startDate).format('DD-MM-YYYY')
        };
        let response = await this.apiService.put('storecheckdashboard/' + storeCheckId + '/duplicate', {}, params);
        if(response?.data){
            newStoreCheckId = response.data;
        }
        return newStoreCheckId;
    }
    
    async deleteStoreCheck(operationId: number, storeCheckId: number) : Promise<boolean>{
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.delete('storecheckdashboard/' + storeCheckId + '/delete', params);
        return (response.error === null);
    }
    
    async cancelStoreCheck(operationId: number, storeCheckId: number) : Promise<boolean>{
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.put('storecheckdashboard/' + storeCheckId + '/cancel', params);
        return (response.error === null);
    }
    
    async loadStoreObjectives (operationId: number, storeId: number, salesRepId: number): Promise<StoreCheckUpdateObjective[]>{
        let storeCheckObjective: Array<StoreCheckUpdateObjective> = [];
        let params = {
            ctxId: operationId,
            salesRepId: salesRepId
        }
        let response = await this.apiService.get('storecheck/' + storeId + '/objectives', params);
        if(response?.data){
            storeCheckObjective = response.data;
        }
        return storeCheckObjective;
    }

    async downloadObjectiveReport(operationId: number, storeCheckId: number, objectiveId: number): Promise<string|null> {
        let base64: string|null = null;
        let params = {
            ctxId: operationId
        }
        let response = await this.apiService.get('storecheckdashboard/' + storeCheckId + '/downloadobjective/' + objectiveId, params);
        if(response?.data?.body){
            base64 = response.data.body;
        }
        return base64;
    }

    async downloadAllObjectivesReports(operationId: number, storeCheckId: number): Promise<string|null> {
        let base64: string|null = null;
        let params = {
            ctxId: operationId
        }
        let response = await this.apiService.get('storecheckdashboard/' + storeCheckId + '/downloadobjective', params);
        if(response?.data?.body){
            base64 = response.data.body;
        }
        return base64;
    }
    
    async loadStoreCheckObjectivesValues(operationId: number, storeCheckId: number): Promise<StoreCheckObjectiveValueDto[]> {
        let values: Array<StoreCheckObjectiveValueDto> = [];
        let params = {
            ctxId: operationId
        }
        let response = await this.apiService.get('storecheck/' + storeCheckId  + '/load/raw/values', params);
        if(response?.data){
            values = response.data;            
        }
        return values;
    }
    
    async saveStoreCheckObjective(operationId: number, data: UpdateStoreCheckObjectiveDto) {        
        let params = {
            ctxId: operationId
        };
        let response = await this.apiService.post('storecheck/saveobjective', data, params);
        return (response.error === null);        
    }
}
